/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Check_RecommendedInputs */

const cs_portals_check_recommended = /** @type {(inputs: Portals_Check_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doporučené`)
};

const en_portals_check_recommended = /** @type {(inputs: Portals_Check_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Portals_Check_RecommendedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_recommended = /** @type {((inputs?: Portals_Check_RecommendedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_RecommendedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_recommended(inputs)
	return cs_portals_check_recommended(inputs)
});